import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1b846d7a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./styles/base.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./App.vue?vue&type=style&index=1&id=1b846d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b846d7a",
  null
  
)

export default component.exports